import { ApplicableOlympiadsInterface } from "~/store/step-15/interfaces/applicableOlympiadsInterface";
import { ApplicableOlympiadsResponseInterface } from "~/store/step-15/interfaces/applicableOlympiadsResponseInterface";
import { ModelItemInterface } from "~/store/step-15/interfaces/modelItemInterface";

const __DEBUG__ = false;

/**
 *
 * @param {ApplicableOlympiadsInterface[]} applicableOlympiads
 * @param {number | string} cgId
 * @return {OlympiadInterface[]}
 */
function getApplicableOlympiadsForCg(applicableOlympiads, cgId) {
  if (__DEBUG__) {
    return __debug__getOlympiadsForCg(applicableOlympiads);
  }
  for (const olympiad of applicableOlympiads) {
    let competitiveGroupId = -123;
    if (typeof olympiad.COMPETITIVE_GROUP === 'string') {
      competitiveGroupId = parseInt(olympiad.COMPETITIVE_GROUP);
    } else {
      if (typeof olympiad.COMPETITIVE_GROUP === 'number') {
        competitiveGroupId = olympiad.COMPETITIVE_GROUP;
      }
    }
    const inputCgId = typeof cgId === "string" ? parseInt(cgId) : cgId;
    if (inputCgId === competitiveGroupId) {
      return olympiad.OLYMPIADS;
    }
  }
  return [];
}

/**
 *
 * @param {ApplicableOlympiadsInterface[]} olympiadList
 * @return {OlympiadInterface[]}
 */
function __debug__getOlympiadsForCg(olympiadList) {
  let res = [];
  for (const olympiad of olympiadList) {
    res.push(...olympiad.OLYMPIADS);
  }
  return res;
}

/**
 *
 * @param {OlympiadInterface[]} olympiadList
 * @param {object} olympiadIds
 * @returns {{id: number, olympiad: OlympiadInterface, selected: boolean}[]}
 */
function getBwe(olympiadList, olympiadIds, selectedBwe, cgId, competitiveGroup) {
  let res = [];

  for (const olympiad of olympiadList) {
    if (olympiad.IS_BWET === true) {
      let isSelected = selectedBwe ? cgId === selectedBwe.typeId && selectedBwe.bweInstance?.olympiad?.ID === olympiad.ID : false;

      if (!isSelected && competitiveGroup) {
        isSelected = olympiad.CODE_OLYMPIAD === competitiveGroup.bwet;
      }

      res.push({
        id: olympiadIds[`${olympiad.ID}${olympiad.PROFILE_ID ?? ''}`],
        olympiad: olympiad,
        selected: isSelected,
      });
    }
  }

  return res;
}

/**
 *
 * @param {OlympiadInterface[]} olympiadList
 * @param {object} olympiadIds
 * @returns {{
 *     disciplineName: string,
 *     olympiads: {
 *       id: number,
 *       olympiad: OlympiadInterface,
 *       selected: boolean,
 *     }[],
 *   }[]}
 */
function getPrivilegesByDisciplines(olympiadList, olympiadIds, oldPrivileges = [], competitiveGroup) {
  let uniqueDisciplines = {};
  for (const olympiad of olympiadList) {
    if (olympiad.DISCIPLINE && olympiad.IS_100 === true && !olympiad.IS_BWET) {
      if (!uniqueDisciplines.hasOwnProperty(olympiad.DISCIPLINE.NAME)) {
        uniqueDisciplines[olympiad.DISCIPLINE.NAME] = [];
      }
      let isSelected = oldPrivileges?.length ? !!oldPrivileges?.find((e) => e.olympiads?.find((o) => o.id == olympiadIds[`${olympiad.ID}${olympiad.PROFILE_ID ?? ''}`] && o.selected)) : false;
      let checkSelected = false;
      if (!isSelected && competitiveGroup) {
        isSelected = !!competitiveGroup.bhs?.find((e) => e === olympiad.CODE_OLYMPIAD);
      }
      if (isSelected) {
        checkSelected = !!uniqueDisciplines[olympiad.DISCIPLINE.NAME].find((e) => e.selected);
      }
      uniqueDisciplines[olympiad.DISCIPLINE.NAME].push({
        id: olympiadIds[`${olympiad.ID}${olympiad.PROFILE_ID ?? ''}`],
        olympiad: olympiad,
        selected: !checkSelected && isSelected,
      });
    }
  }
  let res = [];
  for (const disciplineName in uniqueDisciplines) {
    res.push({ disciplineName: disciplineName, olympiads: uniqueDisciplines[disciplineName] });
  }
  return res;
}

export const state = () => ({
  loading: true,
  /**
   * @type string[]
   */
  excludeBwet: [],
  /**
   * @type string[]
   */
  excludeBhs: [],
  /** @type {ApplicableOlympiadsInterface []} */
  applicableOlympiads: [],
  selectedCg: [],
  /** @type {ModelItemInterface []} */
  model: [],
  /** @type {{
   * cgIndex: number,
   * bweIndex: number,
   * bweInstance: {id: number | undefined, olympiad: OlympiadInterface, selected: boolean},
   * typeId: number,
   * } | boolean} */
  selectedBwe: null,
  selectedOlympiads: {},
  /** @type {{
   * cgIndex: number,
   * disciplineIndex: number,
   * olympiadIndex: number,
   * olympiadInstance: {id: number | undefined, olympiad: OlympiadInterface, selected: boolean}
  }[]} */
  //
  // selectedOlympiads: [],
  dataIsSet: false,
})

export const actions = {
  setBlocks({ commit, state }, params) {
    commit("setBlocks", params)
  },
  async getApplicableOlympiads({ commit, rootState, dispatch, state, rootGetters }, params) {
    commit('setLoading', true);
    const multiBlocks = rootState.multiBlocks.multipleBlocks; //this.$store.getters["multiBlocks/getMultipleBlocks"];
    let addedOlympiads = [];
    let addedOlympiadsProperty = [];

    let olympiadIds = {};

    if (multiBlocks.hasOwnProperty('step_7_1')) {
      for (const multiBlock of multiBlocks['step_7_1']) {
        if (multiBlock.fieldValues !== undefined) {
          const fields = multiBlock.fieldValues;
          const model = multiBlock.blockModel;
          const getFieldLabel = async (code, olympic) => {
            let { value: profileValueId } = fields.find(item => item.code === code) ?? { value: '' }
            if (code === 'OLYMPIAD_LIST_PROFILE') {
              let olympicList = model.items.filter(item => item.code === "OLYMPIAD_LIST_PROFILE")[0].values
              let { label } = olympicList.find(item => item.id === profileValueId) ?? { label: '' }
              return label
            } else {
              let profile = model.items.find(item => item.code === code)
              let { label } = profile?.values?.find(item => item.id === profileValueId) ?? { label: '' }
              return label
            }
          }
          let olympicIndex = fields.findIndex(item => item.code === 'OLYMPIAD_LIST_OLYMPIAD');
          let profileIdValue = fields.find((e) => e.code === 'OLYMPIAD_LIST_PROFILE')?.value ?? '';
          addedOlympiadsProperty.push({
            profile: await getFieldLabel('OLYMPIAD_LIST_PROFILE', fields[olympicIndex].value),
            resultParticipation: await getFieldLabel('OLYMPIAD_LIST_RESULT'),
            olympiad: fields[olympicIndex].value,
            profileId: profileIdValue,
            code: multiBlock.code ?? '',
          })
          addedOlympiads.push(fields[olympicIndex].value);
          olympiadIds[`${fields[olympicIndex].value}${profileIdValue}`] = multiBlock.id;
        }
      }
    }
    if (multiBlocks.hasOwnProperty('step_7_2')) {
      for (const multiBlock of multiBlocks['step_7_2']) {
        if (multiBlock.fieldValues !== undefined) {
          const fields = multiBlock.fieldValues;
          const model = multiBlock.blockModel;
          const getFieldLabel = async (code, olympic) => {
            let { value: profileValueId } = fields.find(item => item.code === code) ?? { value: '' }
            if (code === 'OLYMPIAD_RU_PROFILE') {
              let olympicList = model.items.filter(item => item.code === "OLYMPIAD_RU_PROFILE")[0].values
              let { label } = olympicList.find(item => item.id === profileValueId) ?? { label: '' }
              return label
            } else {
              let profile = model.items.find(item => item.code === code)
              let { label } = profile?.values?.find(item => item.id === profileValueId) ?? { label: '' }
              return label
            }
          }
          let olympicIndex = fields.findIndex(item => item.code === 'OLYMPIAD_RU_OLYMPIAD');
          let profileIdValue = fields.find((e) => e.code === 'OLYMPIAD_RU_PROFILE')?.value ?? '';
          addedOlympiadsProperty.push({
            profile: await getFieldLabel('OLYMPIAD_RU_PROFILE', fields[olympicIndex].value),
            resultParticipation: await getFieldLabel('OLYMPIAD_RU_RESULT'),
            olympiad: fields[olympicIndex].value,
            profileId: profileIdValue,
            code: multiBlock.code ?? '',
          })
          addedOlympiads.push(fields[olympicIndex].value);
          olympiadIds[`${fields[olympicIndex].value}${profileIdValue}`] = multiBlock.id;
        }
      }
    }
    /** @type {GroupCG []} */
    let selectedCg = rootState.application.selectedCompetitionGroup; // this.$store.getters['application/getSelectedCompetitionGroup'];
    commit('setSelectedCg', selectedCg);

    let cgSelectedId = [];
    for (const group of selectedCg) {
      for (const type of group.types) {
        if (type.selected === true) {
          cgSelectedId.push(type.id);
        }
      }
    }
    // ----------------------------- DEBUG PAYLOAD BEGIN ----------------------------- //
    // const payload = {
    //   "competitiveGroups": [21942, 21958],
    //   "olympiads": [6459]
    // };
    // ----------------------------- DEBUG PAYLOAD END ----------------------------- //
    // ----------------------------- REAL PAYLOAD BEGIN ----------------------------- //
    const payload = {
      "competitiveGroups": cgSelectedId,
      "olympiads": addedOlympiads,
    };
    // ----------------------------- REAL PAYLOAD BEGIN ----------------------------- //
    /*console.log('DEBUG *********** Step-15 store getApplicableOlympiads endpoint response. BEGIN >>> ');
    console.log('request payload: ', payload);*/
    let ApplicableOlympiads = [];
    if (addedOlympiads.length > 0 && cgSelectedId.length > 0) {
      const response = await this.$api("getApplicableOlympiads", payload, "POST");
      if (response.code === 200) {
        response.data.ApplicableOlympiads.forEach((olympiadGroup) => {
          olympiadGroup.OLYMPIADS.forEach((olympiad) => {
            const currentProperty = addedOlympiadsProperty.find(item => {
              if (item.olympiad === olympiad.ID) {
                return item.profileId ? item.profileId === olympiad.PROFILE_ID : true;
              }
              return false;
            })
            if (currentProperty?.profile) olympiad.DISPLAY_NAME += ', ' + currentProperty.profile;
            else if (olympiad.DISCIPLINE?.NAME) olympiad.DISPLAY_NAME += ', ' + olympiad.DISCIPLINE?.NAME ?? '';
            if (currentProperty?.resultParticipation) olympiad.DISPLAY_NAME += ', ' + currentProperty.resultParticipation;
            if (currentProperty?.code) {
              olympiad['CODE_OLYMPIAD'] = currentProperty.code;
            }
          })
        })
        ApplicableOlympiads = response.data.ApplicableOlympiads;
        commit('setApplicableOlympiads', response.data);
      } else {
        /*console.error('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! Some error --BEGIN--!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
        console.error('store/step-15/actions.getApplicableOlympiads');
        console.error('response code is not equal 200. Actual response code: ', response.code);
        console.error('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! Some error --END--!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');*/
        return;
      }
    }
    /** @type ApplicableOlympiadsResponseInterface */

    //console.log('DEBUG *********** Step-15 store getApplicableOlympiads endpoint response. END <<< ');
    let model = [];

    for (const cg of selectedCg) {
      for (const type of cg.types) {
        if (type.selected === true) {
          const olympiadsForCg = getApplicableOlympiadsForCg(ApplicableOlympiads, type.id);
          const tempCg = rootGetters['application/getCompetitiveGroups'].find((e) => e.id === type.id);
          const bwe = getBwe(olympiadsForCg, olympiadIds, state.selectedBwe, type.id, tempCg);
          const oldDisciplines = rootGetters['application/getAppFormViewMode'] !== 'view' ? state.model.find((e) => e.type.code == type.code)?.privilegesByDisciplines ?? [] : [];
          const privilegesByDisciplines = getPrivilegesByDisciplines(olympiadsForCg, olympiadIds, oldDisciplines, tempCg);
          model.push({
            selectedCompetitionGroup: cg,
            type,
            bwe,
            privilegesByDisciplines,
          });
        }
      }
      // console.log(cg);
      // const olympiads = getOlympiadsForCg(state.applicableOlympiads, cg.)
      // model.push({selectedCompetitionGroup: cg});
    }
    await dispatch('setModelBweData', { competitiveGroups: rootState.application.competitiveGroups, model });
    // commit('setModel', model);

    // if (!state.dataIsSet) {
    //   commit('setData', { competitiveGroups: rootState.application.competitiveGroups, model })
    // }

    commit('setLoading', false);
  },
  async setModelBweData({ commit, state }, { competitiveGroups, model }) {
    let bwe = null;
    if (!state.dataIsSet) {
      commit('setDataIsSet', true);
      let quota = '';
      // let oneHundredQuota = [];
      let id = null;

      competitiveGroups.forEach(item => {
        if (item.bwet !== '') {
          quota = item.bwet
          id = item.id
        }
        // if (item.bhs.length) {
        //   oneHundredQuota.push({ [item.id]: item.bhs })
        // }
      })

      let bweInstance = {};
      let bweIndex = 0;
      let cgIndex = 0;

      if (model.length) {
        const modelBwe = model.find((e) => e.bwe?.find((el) => el.id === quota))

        modelBwe?.bwe?.map((item, index) => {
          if (item.id == quota) {
            item.selected = false;
            bweInstance = item;
            bweIndex = index;
          }
        })
        // oneHundredQuota.forEach(oHQuota => {

        //   const cg = model.filter(model => model.type.id == Object.keys(oHQuota)[0]);

        //   if (cg) {
        //     cg[0]?.privilegesByDisciplines?.forEach(privilege => {
        //       privilege.olympiads?.forEach(olimpiad => {

        //         if (Object.values(oHQuota)[0].includes(olimpiad.id)) {
        //           olimpiad.selected = true;
        //         }
        //       })
        //     })
        //   }
        // })

        model.forEach((item, index) => {
          if (item.type.id == id) {
            cgIndex = index
          }
        })

        // model.find((m) => {
        //   m.bwe.find((b) => {
        //     if ()
        //   })

        // })
        // model.forEach(m => {
        //   const typeId = m.type.id
        //   const bweParams = competitiveGroups.find(e => e.id === typeId)
        //   if (!bweParams && !bweParams?.bwet) {
        //     return
        //   }
        //   const bweId = bweParams.bwet
        //   m.bwe.forEach(b => {
        //     if (b.id === bweId) {
        //       b.selected = true
        //     }
        //   })
        // })

      }

      if (quota) {
        bwe = {
          bweIndex: bweIndex,
          bweInstance: bweInstance,
          typeId: id,
          cgIndex: cgIndex,
        }
      }
    }
    commit('setData', { model, selectedBwe: bwe });
  },
}

export const mutations = {
  setLoading(state, payload = true) {
    state.loading = payload
  },
  setBlocks(state, params) {
    state.selectedOlympiads = params
  },
  setStartStatus(state) {
    state.dataIsSet = false;
  },
  setDataIsSet(state, value) {
    state.dataIsSet = value ?? false;
  },
  setData(state, { model, selectedBwe }) {
    if (selectedBwe) {
      state.selectedBwe = selectedBwe;
    }
    state.model = model;
    // state.dataIsSet = true;

    // let quota = '';
    // let oneHundredQuota = [];
    // let id = null;

    // params.map(item => {
    //   if (item.bwet !== '') {
    //     quota = item.bwet
    //     id = item.id
    //   }
    //   if (item.bhs.length) {
    //     oneHundredQuota.push({ [item.id]: item.bhs })
    //   }
    // })

    // let bweInstance = {};
    // let bweIndex = 0;
    // let cgIndex = 0;

    // if (state.model.length) {
    //   const modelBwe = state.model.find((e) => e.bwe?.find((el) => el.id === quota))

    //   modelBwe?.bwe?.map((item, index) => {
    //     if (item.id == quota) {
    //       item.selected = false
    //       bweInstance = item
    //       bweIndex = index
    //     }
    //   })

    //   oneHundredQuota.forEach(oHQuota => {

    //     const cg = state.model.filter(model => model.type.id == Object.keys(oHQuota)[0]);

    //     if (cg) {
    //       cg[0]?.privilegesByDisciplines?.forEach(privilege => {
    //         privilege.olympiads?.forEach(olimpiad => {

    //           if (Object.values(oHQuota)[0].includes(olimpiad.id)) {
    //             olimpiad.selected = true;
    //           }
    //         })
    //       })
    //     }
    //   })

    //   state.model.map((item, index) => {
    //     if (item.type.id == id) {
    //       cgIndex = index
    //     }
    //   })

    //   state.model.forEach(m => {
    //     const typeId = m.type.id
    //     const bweParams = params.find(e => e.id === typeId)
    //     if (!bweParams && !bweParams?.bwet) {
    //       return
    //     }
    //     const bweId = bweParams.bwet
    //     m.bwe.forEach(b => {
    //       if (b.id === bweId) {
    //         b.selected = true
    //       }
    //     })
    //   })

    // }

    // if (quota) {
    //   const bwe = {
    //     bweIndex: bweIndex,
    //     bweInstance: bweInstance,
    //     typeId: id,
    //     cgIndex: cgIndex,
    //   }
    //   state.selectedBwe = bwe
    // }
  },
  setApplicableOlympiads(state, params) {
    //console.log('>>>>>>>>>>', params);
    if (params !== undefined && params !== null) {
      state.applicableOlympiads = params;
    }
  },
  setSelectedCg(state, params) {
    state.selectedCg = params;
  },
  setModel(state, params) {
    state.model = params;
  },
  /**
   *
   * @param {any} state
   * @param {{
   *    modelItemIndex: number,
   *    bwe: {id: number | undefined, olympiad: OlympiadInterface, selected: boolean}
   * }} params
   */
  selectBwe(state, params) {
    // console.log('params :>> ', params);
    let item = state.model[params.modelItemIndex];
    // for(let bwe of item.bwe) {
    for (let i = 0; i < item.bwe.length; i += 1) {
      // let bwe = item.bwe[i];
      if (item.bwe[i].id === params.bwe.id &&
        item.bwe[i].olympiad.ID === params.bwe.olympiad.ID &&
        item.bwe[i].olympiad.CODE === params.bwe.olympiad.CODE &&
        item.bwe[i].olympiad.NAME === params.bwe.olympiad.NAME
      ) {
        item.bwe[i].selected = true;
        /*item.*/
        state.selectedBwe = {
          cgIndex: params.modelItemIndex,
          bweIndex: i,
          bweInstance: item.bwe[i],
          typeId: item.type.id,
        }
        //state.excludeBhs.push(item.bwe[i].olympiad.ID);        
        for (let i = 0; i < item.privilegesByDisciplines.length; i++) {
          let pd = item.privilegesByDisciplines[i];
          let index = pd.olympiads.findIndex(olympiad => olympiad.id === params.bwe.id);
          if (index !== -1) {
            pd.olympiads[index].selected = false;
            break;
          }
        }
        // break;
      }
    }
  },
  deselectBwe(state) {
    if (state.selectedBwe === false) {
      return;
    }
    const cgIndex = state.selectedBwe.cgIndex;
    const bweIndex = state.selectedBwe.bweIndex;

    if (!state.model[cgIndex].bwe[bweIndex]) {
      return;
    }
    state.model[cgIndex].bwe[bweIndex].selected = false;
    state.selectedBwe = null;
  },
  /**
   *
   * @param state
   * @param {{ cgIndex: number, disciplineIndex: number, olympiad: OlympiadInterface }} params
   */
  selectOlympiad(state, params) {
    let disciplineOlympiads = state.model[params.cgIndex].privilegesByDisciplines[params.disciplineIndex].olympiads;
    if (!params.olympiad) {
      for (let i = 0; i < disciplineOlympiads.length; i += 1) {
        if (disciplineOlympiads[i].selected) {
          disciplineOlympiads[i].selected = false;
        }
      }
    } else {
      for (let i = 0; i < disciplineOlympiads.length; i += 1) {
        let olympiad = disciplineOlympiads[i];
        if (olympiad.selected && olympiad.olympiad.ID !== params.olympiad.ID) {
          olympiad.selected = false;
        }
        if (
          olympiad.olympiad.ID === params.olympiad.ID &&
          olympiad.olympiad.PROFILE_ID === params.olympiad.PROFILE_ID &&
          olympiad.olympiad.CODE === params.olympiad.CODE &&
          olympiad.olympiad.NAME === params.olympiad.NAME && !olympiad.selected
        ) {

          olympiad.selected = true;
        }
      }
    }
  },
  changeOlympiad(state, params) {
    const { disciplineParams, indexModel } = params;
    if (disciplineParams.length) {
      const model = state.model[indexModel];
      model.privilegesByDisciplines.forEach((e) => {
        const disciplineParamsItem = disciplineParams.find((el) => el.disciplineName === e.disciplineName);
        if (disciplineParamsItem && disciplineParamsItem.olympiad) {
          e.olympiads.forEach((el) => {
            if (
              el.olympiad.ID === disciplineParamsItem.olympiad.ID &&
              el.olympiad.PROFILE_ID === disciplineParamsItem.olympiad.PROFILE_ID &&
              el.olympiad.NAME === disciplineParamsItem.olympiad.NAME
            ) {
              el.selected = true;
            } else {
              el.selected = false;
            }
          })
          return;
        }

        const result = e.olympiads?.find((el) => el.selected);
        if (result) {
          result.selected = false;
        }
      })
    } else {
      state.model[indexModel]?.privilegesByDisciplines?.forEach((e) => {
        const tempOl = e.olympiads?.find((el) => el.selected);
        if (tempOl) {
          tempOl.selected = false;
        }
      })
    }
  }
}

export const getters = {
  getLoading: (state) => {
    return state.loading;
  },
  getApplicableOlympiads: (state) => {
    return state.applicableOlympiads;
  },
  getSelectedCompetitionGroup: (state) => {
    return state.selectedCg;
  },
  getCompetitionGroupByModelIndex: (state) => (index) => {
    if (!state.model.length || index < 0) {
      return null;
    }
    return state.model[index]?.selectedCompetitionGroup ?? null;
  },
  getModel: (state) => {
    return state.model;
  },
  getSelectedBwe: (state) => {
    return state.selectedBwe;
  },
  getSelectedOlympiad: (state) => {
    return state.selectedOlympiads;
  },
  getExcludeBwet: (state) => {
    return state.excludeBwet;
  },
  getExcludeBhs: (state) => {
    return state.excludeBhs;
  },
  getStartStatus: (state) => {
    return state.dataIsSet;
  },
  isSelectedOlympiad: (state) => {
    return !!state.model.find((e) => !!e.privilegesByDisciplines?.find((d) => !!d.olympiads?.find((o) => o.selected)))
  }
}
